"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleContent = void 0;
var React = require("react");
var Icons_1 = require("../../Icons");
var DropdownParent_1 = require("../../Internal/DropdownParent/DropdownParent");
var Localization_1 = require("../../Localization");
var Searcher_1 = require("../../Searcher");
var Searcher_styles_1 = require("../../Searcher/Searcher.styles");
var Thumbnails_1 = require("../../Thumbnails");
var EntryPicker_styles_1 = require("./EntryPicker.styles");
exports.ToggleContent = React.forwardRef(function (_a, ref) {
    var OnSearch = _a.OnSearch, OnClearSearch = _a.OnClearSearch, AriaLabel = _a.AriaLabel, LabelledBy = _a.LabelledBy, OnKeyUp = _a.OnKeyUp, SelectedEntry = _a.SelectedEntry, SearchValue = _a.SearchValue, IsDisabled = _a.IsDisabled, IsRequired = _a.IsRequired, HasErrors = _a.HasErrors;
    React.useImperativeHandle(ref, function () { return ({
        handleEscapeKeyPressed: function () {
            handleClearSearch();
        },
    }); });
    var _b = React.useContext(DropdownParent_1.DropdownParentContext), SetDropdownVisibility = _b.SetDropdownVisibility, IsDropdownOpen = _b.IsDropdownOpen;
    var inputControl = React.createRef();
    React.useEffect(function () {
        if (!SelectedEntry && inputControl && IsDropdownOpen) {
            inputControl.current.focus();
        }
    }, [inputControl]);
    var buildSelectedEntryDisplayName = function () {
        var result = SelectedEntry.FirstName + " " + SelectedEntry.LastName;
        if (!SelectedEntry.PreferredName) {
            return result;
        }
        return result + " (" + SelectedEntry.PreferredName + ")";
    };
    var handleOnClick = function () {
        if (!IsDisabled && !IsDropdownOpen) {
            SetDropdownVisibility(true);
        }
    };
    var handleClearSearch = function () {
        SetDropdownVisibility(false);
        OnClearSearch();
    };
    var handleOnSearch = function (search) {
        if (!IsDropdownOpen) {
            SetDropdownVisibility(true);
        }
        OnSearch(search);
    };
    return (React.createElement("div", { onClick: handleOnClick }, SelectedEntry ? (React.createElement(EntryPicker_styles_1.SelectedEntryContainer, null,
        React.createElement(Thumbnails_1.AvatarThumbnail, { Src: SelectedEntry.AvatarInfo.Src, AltText: SelectedEntry.AvatarInfo.AltText, Initials: SelectedEntry.AvatarInfo.Initials, OccupantSpecies: SelectedEntry.AvatarInfo.OccupantSpecies, Size: "Smallest", Role: "presentation" }),
        React.createElement(EntryPicker_styles_1.SelectedEntryP, null, buildSelectedEntryDisplayName()),
        React.createElement(Searcher_styles_1.HeadingButton, { onClick: handleClearSearch, "aria-label": Localization_1.strings.EntryPicker_Label_ClearSearch, title: Localization_1.strings.EntryPicker_Label_ClearSearch, disabled: IsDisabled },
            React.createElement(Icons_1.CloseThinIcon, null)))) : (React.createElement(EntryPicker_styles_1.SearchContainer, null,
        React.createElement(Thumbnails_1.AvatarThumbnail, { AltText: "", Size: "Smallest", Role: "presentation" }),
        React.createElement(Searcher_1.Searcher, { AriaLabel: AriaLabel, LabelledBy: LabelledBy, InitialSearch: SearchValue, OnKeyUp: OnKeyUp, ref: inputControl, OnSearch: handleOnSearch, OnClear: handleClearSearch, Placeholder: Localization_1.strings.EntryPicker_Message_SearchPlaceholder, IsDisabled: IsDisabled, IsRequired: IsRequired, HasErrors: HasErrors })))));
});
